import * as React from "react";
const SvgPowerHost = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.147v3.687a.5.5 0 0 0 .792.406l2.202-1.585 2.215 1.588A.5.5 0 0 0 9 14.837v-3.69a6.223 6.223 0 0 1-3 .766 6.223 6.223 0 0 1-3-.766Z"
      fill="currentColor"
    />
    <circle cx={6} cy={5.663} r={5} fill="currentColor" />
  </svg>
);
export default SvgPowerHost;
